import axios from 'axios'

import * as Helper from '@/shared/helper'

const login = (data)=>{
	return axios.post(`${Helper.envi.VUE_APP_API_URL}/Admin/Auth`, data)
  .then((res)=>{
    return res.data
  }).catch((err)=>{
    console.log(err.response)
    return err.response.data
  })
}

const session = {
	delete:(item)=>{
    if(!item){
      localStorage.removeItem('passport')
      localStorage.removeItem('pass_expire')
      localStorage.removeItem('session')
    }else{
      localStorage.removeItem(item)
    }
  },
  create:(session)=>{
    console.log(session)
    localStorage.setItem('role', session.role)
    localStorage.setItem('office', (session.office_id?session.office_id:''))
    localStorage.setItem('passport', Helper.encrypt(session.passport))
    localStorage.setItem('pass_expire', Date.now().toString())
    localStorage.setItem('session', JSON.stringify(session))
    // console.log(localStorage)
  },
  get:(item)=>{
    let data = null
    
    if(!item){
      if(localStorage.getItem('passport') != null) {
        data = Helper.decrypt(localStorage.getItem('passport'))
      }
      let session = {
        passport:data
      }
      return session
    }else{
      if(localStorage.getItem('passport') != null){
        data = localStorage.getItem(item)
        
        return data
      }
    }
  }
}

const checkSession = (redirect)=>{
  let timestamp = session.get('pass_expire')
  let currentTimestamp = Date.now()

  if(((currentTimestamp - timestamp)/1000/60/60) > 2){
    session.delete()
    location.reload()
  }
  return true;
}

export {
	login,
  session,
  checkSession
}